<template>
  <div :id="subSection.id"
       class="pdf-preview-sub-section-header">
    <div class="content-row">
      <div class="item-no left"></div>
      <div class="sub-section-name" v-html="subSection.name"></div>
      <div class="item-no right"></div>
    </div>
    <div class="content-row"
         v-if="subSection.descriptions.length > 0">
      <div class="item-no left flat"></div>
      <div class="sub-section-descriptions" v-html="replaceItemNo(subSection.descriptions)"></div>
      <div class="item-no right flat"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubSectionHeader',
  props: {
    section: Object,
    subSection: Object,
  },
  setup(props, {root}) {
    const replaceItemNo = function (str) {
      return str.replaceAll(/({{[0-9]+}})/g, (match) => {
        let withoutBrackets = match.replace('{{', '').replace('}}', '')

        return `${props.section.order_no.toString().padStart(2, '0')}${withoutBrackets.padStart(3, '0')}`
      })
    };

    return {
      replaceItemNo,
    }
  }
}
</script>
